import cigarette_icon from 'src/assets/cigarette_icon.svg'
import coffee_icon from 'src/assets/coffee_icon.svg'
import gaming_controller_icon from 'src/assets/gaming_controller_icon.svg'
import internet_addiction_icon from 'src/assets/internet_addiction_icon.svg'

export const ADDICTION_TYPES_PAGES = {
  addictionTypeSelection: 'addictionTypeSelection',
  addictionFrequencySelection: 'addictionFrequencySelection',
  goalSelection: 'goalSelection',
}

export const FREQUENCY_RATE_OPTIONS = [
  { id: 'day', title: 'Day' },
  { id: 'week', title: 'Week' },
  { id: 'month', title: 'Month' },
]

export const ADDICTION_TYPES_OPTIONS = [
  {
    value: 'domain_internet_addiction',
    image: internet_addiction_icon,
    title: 'Internet Addiction',
    //   subtext: 'asdfasd',
  },
  {
    value: 'domain_gaming_addiction',
    image: gaming_controller_icon,
    title: 'Gaming Addiction',
    //   subtext: 'asdfasd',
  },
  {
    value: 'domain_caffine_addiction',
    image: coffee_icon,
    title: 'Caffeine Addiction',
    //   subtext: 'asdfasd',
  },
  {
    value: 'domain_smoking_addiction',
    image: cigarette_icon,
    title: 'Smoking Addiction',
    //   subtext: 'asdfasd',
  },
]

export function redirectToRelevantAssessment({ addictionType, navigate }) {
  switch (addictionType) {
    case ADDICTION_TYPES_OPTIONS?.[0]?.value:
      navigate('/assessment/distress-assessment-1')
      break
    case ADDICTION_TYPES_OPTIONS?.[1]?.value:
      navigate('/assessment/gaming-addiction')
      break
    case ADDICTION_TYPES_OPTIONS?.[2]?.value:
      navigate('/assessment/caffeine-addiction')
      break
    case ADDICTION_TYPES_OPTIONS?.[3]?.value:
      navigate('/assessment/nicotine-dependency')
      break
    default:
      navigate('/personalized-plan/behavioral-addiction-plan')
      break
  }
}
